import { patchRequest } from '@helpers/request'
import { logger } from '@helpers/logger'

/**
 * Update team display name
 * @param {Object} teamData - Team data containing teamKey, teamDisplayName, sport, league, season
 * @returns {Promise} - Response from the server
 */
export const teamAdmin = async (teamData) => {
  const params = {
    teamKey: teamData.teamKey,
    sport: teamData.sport,
    league: teamData.league,
    season: teamData.season,
  }

  const logComplete = logger.serviceRequest('teamAdmin', params)

  try {
    console.log('teamAdmin service called with:', teamData)

    const { response, logComplete: requestLogComplete } = await patchRequest('admin/teamAdmin', {
      teamKey: teamData.teamKey,
      teamDisplayName: teamData.teamDisplayName,
      sport: teamData.sport,
      league: teamData.league,
      season: teamData.season,
    })

    requestLogComplete()
    logComplete()

    console.log('teamAdmin service response:', response)
    return response
  } catch (error) {
    logger.error('teamAdmin service error:', error)
    logComplete()
    throw error
  }
}
